import {
  Box,
  Button,
  IconButton,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useState } from "react";
import { BalootUserAPIs } from "../../../api/APIs";
import { useRequest } from "../../../api/utils/useRequest";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ReactComponent as CheckBoxLogo } from "../../../assets/icons/check-box-colored.svg";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";

function DirectDebitSetBankPage() {
  const navigate = useNavigate();
  const { editableSubscription, setEditableSubscription } = useOutletContext();
  const [selectedBank, setSelectedBank] = useState(editableSubscription.bank);
  const {
    loading,
    result,
    apiCall: getBanks,
  } = useRequest(BalootUserAPIs.getBanks);

  const handleSubmit = () => {
    setEditableSubscription((prev) => {
      return { ...prev, bank: selectedBank };
    });
    navigate(-1);
  };

  const isActive = (bank) => {
    return selectedBank?.id === bank.id;
  };

  useEffect(() => {
    getBanks();
  }, []);
  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            پس‌انداز خودکار
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <Typography variant="subtitle1" color="grey.2" align="center">
          در حال حاضر قابلیت پس‌انداز خودکار فقط برای دارندگان حساب در بانک‌های
          زیر فعال است. با انتخاب بانک مورد نظر به مرحله بعد بروید
        </Typography>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {loading ? (
            <>
              {Array(12)
                .fill(null)
                .map((item, index) => {
                  return (
                    <CustomRectangularSkeleton
                      key={index}
                      width={80}
                      height={80}
                      sx={{ m: 1 }}
                    />
                  );
                })}
            </>
          ) : (
            result &&
            result.map((bank) => {
              return (
                <Box
                  onClick={() => {
                    setSelectedBank(bank);
                  }}
                  key={bank.id}
                  sx={[
                    {
                      p: "16px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      minWidth: 100,
                      maxWidth: 100,
                    },
                    selectedBank &&
                      !isActive(bank) && { bgcolor: "grey.6", opacity: 0.5 },
                  ]}
                >
                  <Box sx={{ height: 20, width: 20, mb: "8px" }}>
                    {isActive(bank) && <CheckBoxLogo width={20} height={20} />}
                  </Box>
                  <img src={bank.logoUrl} width={48} height={48} />
                  <Typography
                    mt={"8px"}
                    variant="body2"
                    color="grey.3"
                    align="center"
                  >
                    {bank.name}
                  </Typography>
                </Box>
              );
            })
          )}
        </Box>
        <BottomFullWidthButtonContainer>
          <Button
            disabled={!selectedBank}
            onClick={handleSubmit}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            مرحله بعدی
          </Button>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
    </>
  );
}

export default DirectDebitSetBankPage;
